import type { EventContext } from './types'
import { isBrowser } from './utils'

export function buildBrowserContext(): EventContext {
  if (!isBrowser()) {
    return {}
  }

  return {
    locale: navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    page: {
      path: window.location.pathname,
      url: window.location.href,
      title: document.title,
      referrer: document.referrer,
    },
  }
}

export function buildServerContext(): EventContext {
  return {
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  }
}
